/**
 * @flow
 * @relayHash 387bd6bc7511dd6be91477e49fe318b9
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type scheduleInviteHyeventInput = {|
  clientMutationId?: ?string,
  id: string,
  inviteScheduleAt: string,
  invitedGroups: string,
|};
export type scheduleEventMutationVariables = {|
  input: scheduleInviteHyeventInput
|};
export type scheduleEventMutationResponse = {|
  +scheduleInviteHyevent: ?{|
    +clientMutationId: ?string,
    +hyevent: ?{|
      +additionalGuestAllowed: boolean,
      +id: string,
      +publishAt: ?any,
      +campaignTested: ?boolean,
      +status: string,
      +title: string,
    |},
  |}
|};
export type scheduleEventMutation = {|
  variables: scheduleEventMutationVariables,
  response: scheduleEventMutationResponse,
|};
*/


/*
mutation scheduleEventMutation(
  $input: scheduleInviteHyeventInput!
) {
  scheduleInviteHyevent(input: $input) {
    clientMutationId
    hyevent {
      additionalGuestAllowed
      id
      publishAt
      campaignTested
      status
      title
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "scheduleInviteHyeventInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "scheduleInviteHyevent",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "scheduleInviteHyeventPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "clientMutationId",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "hyevent",
        "storageKey": null,
        "args": null,
        "concreteType": "Hyevent",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "additionalGuestAllowed",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "publishAt",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "campaignTested",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "status",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "title",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "scheduleEventMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "scheduleEventMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "scheduleEventMutation",
    "id": null,
    "text": "mutation scheduleEventMutation(\n  $input: scheduleInviteHyeventInput!\n) {\n  scheduleInviteHyevent(input: $input) {\n    clientMutationId\n    hyevent {\n      additionalGuestAllowed\n      id\n      publishAt\n      campaignTested\n      status\n      title\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a875bb26666816f3a3ecd5a2da6a94a4';
module.exports = node;
